<template>
  <div class="teamsize-selector-wrap">
    <div class="update-teamsize-selector">
      <GekkoButton
        @click="decreaseTeamSize"
        :disabled="(teamSize - minTeamSize) < 1"
        icon="fa-solid fa-minus"
      />
      <span>{{ teamSize - minTeamSize }}</span>
      <GekkoButton
        @click="increaseTeamSize"
        icon="fa-solid fa-plus"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import GekkoButton from "@/components/GekkoButton"

export default {
  name: "TeamsizeSelector",
  components: { 
    GekkoButton
  },
  props: {},
  data () {
    return {}
  },
  computed: {
    ...mapGetters({ 
      minTeamSize: 'subscriptionStore/getMinTeamSize',
      storedTeamSize: 'subscriptionStore/getTeamSize',
    }),
    teamSize: {
      get () { return this.storedTeamSize },
      set (value) { this.$store.commit('subscriptionStore/SET_TEAM_SIZE', value) },
    },
    updatedTeamSize () {
      return (this.teamSize > this.minTeamSize)
    }
  },
  methods: {
    decreaseTeamSize () {
      if (this.teamSize > this.minTeamSize) this.teamSize--
    },
    increaseTeamSize () {
      this.teamSize++
    },
  },
}
</script>

<style lang="scss" scoped>
  .teamsize-selector-wrap {
    text-align: center; 
    display: flex; 
    align-items: center; 
    .teamsize-selector__icon {
      margin-right: 0.75rem; 
      opacity: 0.3;
      > svg { width: 30px; height: 30px; }
    }
    .update-teamsize-selector {
      border-radius: $radiusMd;
      outline: 1px solid $colorBorderDash;
      font-size: 20px;
      padding: 0.5rem 0.25rem;
      display: inline-block;
      white-space: nowrap;
      > span { padding: 0 0.5rem; }
      button {
        background: transparent !important;
        color: $colorBrand !important;
        border: none !important;
        padding: 2px 0.5rem;
        &.disabled { color: $colorUnassigned !important; }
      }
    }
    @media (min-width: '768px') {
      .teamsize-selector__icon {
        > svg { width: 30px; height: 30px; }
      }
    }
  }
</style>